import { HttpEvent } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Entity, User } from '@apps/auth/domain/models/back';
import { Site } from '@apps/priv/models/site';
import { AppliRole } from '@apps/back/models';
import { MediaTypes } from '@common/services';
import { EntityMaster, EntityBackupDefinition } from '@apps/auth/domain/models/back/entity-backup-definition';
import { EntityComputeDefinition, VeeamFilter, VmwareFilter } from '@apps/auth/domain/models/back/entity-compute-definition';

export const BackAuthEntityDetailsRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Entity Details Requested',
    props<{ entityId: string }>()
);
export const BackAuthEntityDetailsSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Details Succeeded',
    props<{ entity: Entity }>()
);
export const BackAuthEntityDetailsFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Entity Details Failed',
    props<{ err: any }>()
);
export const BackAuthEntitySelectedReset = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Selected Reset',
);


export const BackAuthEntitySitesSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Sites Succeeded',
    props<{ sites: Site[] }>()
);
export const BackAuthEntityReferentsRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Referents Requested',
    props<{ entityId: string }>()
);

export const BackAuthEntityReferentsSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Referents Succeeded',
    props<{ referents: User[] }>()
);
export const BackAuthEntityExportRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Export Requested',
    props<{ qs: string, format: MediaTypes }>()
);
export const BackAuthEntityExportSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Export Succeeded',
    props<{ response: HttpEvent<Blob> }>()
);
export const BackAuthEntityExportFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Export Failed',
    props<{ failure: any }>()
);
// #region Users d'une entité
export const BackAuthEntityUsersRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Users Requested',
    props<{ entityId: string }>()
);
export const BackAuthEntityUsersSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Users Succeeded',
    props<{ users: User[] }>()
);

export const BackAuthEntityUsersQsWordImpeSet = createAction(
    '[BACK-AUTH-USERS] Back Auth Entity Users QsWord ImpeSet',
    props<{ qsWordImpe: string }>()
);
export const BackAuthEntityAddReferentRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Referent Requested',
    props<{ entityId: string, userId: string }>()
);
export const BackAuthEntityAddReferentSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Referent Succeeded',
    props<{ referents: User[] }>()
);
export const BackAuthEntityAddReferentFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Referent Failed',
    props<{ err: any }>()
);
export const BackAuthEntityRemoveReferentRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Remove Referent Requested',
    props<{ entityId: string, userId: string }>()
);
export const BackAuthEntityRemoveReferentSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Remove Referent Succeeded',
    props<{ referents: User[] }>()
);
export const BackAuthEntityRemoveReferentFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Remove Referent Failed',
    props<{ err: any }>()
);
export const BackAuthEntityUserSelectedSet = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity User SelectedSet',
    props<{ user: User }>()
);
export const BackAuthEntityUsersExportRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Users Export Requested',
    props<{ entityId: string, format: MediaTypes }>()
);
export const BackAuthEntityUsersExportSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Users Export Succeeded',
    props<{ response: HttpEvent<Blob> }>()
);
export const BackAuthEntityUsersExportFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Users Export Failed',
    props<{ failure: any }>()
);
export const BackAuthEntityAddHabilitationRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Habilitation Requested',
    props<{ external: boolean, entityId: string, appRole: AppliRole }>()
);
export const BackAuthEntityRemoveHabilitationRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Remove Habilitation Requested',
    props<{ entityId: string, appRole: AppliRole }>()
);

export const BackAuthEntityAddHabilitationSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Habilitation Succeeded',
    props<{ appRole: AppliRole }>()
);
export const BackAuthEntityRemoveHabilitationSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Remove Habilitation Succeeded',
    props<{ appRole: AppliRole }>()
);
export const BackAuthEntityAddHabilitationFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Habilitation Failed',
    props<{ appRole: AppliRole }>()
);
export const BackAuthEntityRemoveHabilitationFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Remove Habilitation Failed',
    props<{ appRole: AppliRole }>()
);
export const BackAuthEntityUpdateBackupDefinitionRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Backup Query Definition Requested',
    props<{entityId: string, BackupDefinitions: EntityMaster[]}>()
);
export const BackAuthEntityUpdateBackupDefinitionSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Backup Query Definition Succeeded',
    props<EntityBackupDefinition>()
);
export const BackAuthEntityUpdateBackupDefinitionFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Backup Query Definition Failed',
    props<any>()
);
export const BackAuthEntityUpdateVmwareDefinitionRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Vmware Definition Requested',
    props<{ entityId: string, vmwareFilters: VmwareFilter[]}>()
);
export const BackAuthEntityUpdateVmwareDefinitionSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Vmware Definition Succeeded',
    props<EntityComputeDefinition>() 
);
export const BackAuthEntityUpdateVmwareDefinitionFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Vmware Definition Failed',
    props<any>()
);
export const BackAuthEntityUpdateVeeamDefinitionRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Veeam Definition Requested',
    props<{ entityId: string, veeamFilters: VeeamFilter[]}>()
);
export const BackAuthEntityUpdateVeeamDefinitionSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Veeam Definition Succeeded',
    props<EntityComputeDefinition>()
);
export const BackAuthEntityUpdateVeeamDefinitionFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Update Veeam Definition Failed',
    props<any>()
);
export const BackAuthEntityUsersUpdateQueryStringRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Users Update QueryString Requested',
    props<{ queryString: string }>()
);

export const BackAuthEntityUsersAddQueryParameterRequested = createAction(
    '[BACK-AUTH-USER] Back Auth Users External Add Query Parameter Requested',
    props<{ key: string, value: any }>()
);
export const BackAuthEntityUsersRemoveQueryParameterRequested = createAction(
    '[BACK-AUTH-USER] Back Auth Users External Remove Query Parameter Requested',
    props<{ key: string }>()
);
